export const FETCH_COMMUNITY_ABOUT = 'FETCH_COMMUNITY_ABOUT';
export const FETCH_COMMUNITY_ABOUT_SUCCESS = 'FETCH_COMMUNITY_ABOUT_SUCCESS';
export const FETCH_COMMUNITY_ABOUT_FAILURE = 'FETCH_COMMUNITY_ABOUT_FAILURE';
